import { inject, Pipe, PipeTransform } from '@angular/core';
import { BrandModel } from 'models/generated/Entities.GormCrm.Brand';
import { BrandService } from 'services/brand.service';

@Pipe({ name: 'brand' })
export class BrandPipe implements PipeTransform {

	private brandService = inject(BrandService);

	transform(brand?: BrandModel | string, format?: string): string {

		if (typeof brand === 'string') brand = this.brandService.getBrand(brand) ?? undefined;
		if (!brand) return '';

		switch (format) {
			case 'shortName':
				return brand.shortName;
			default:
				return brand.name;
		}
	}
}
